import { action, observable, runInAction } from 'mobx'

export default class FavoritesView {
  rootStore = null

  @observable accessor isInitializing = false
  @observable accessor isInitialized = false
  @observable accessor favoriteUsers = []

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  init = async () => {
    if (this.isInitializing) return

    runInAction(() => {
      this.isInitializing = true
    })

    await this.#loadData()

    runInAction(() => {
      this.isInitializing = false
      this.isInitialized = true
    })

    this.analytics.dashboard()?.then()
  }

  @action
  reset = () => {
    this.favoriteUsers = []
    this.isInitializing = false
    this.isInitialized = false
  }

  get analytics() {
    return this.rootStore.analyticsStore
  }

  get api() {
    return this.rootStore.apiStore
  }

  get users() {
    return this.rootStore.repositories.usersRepository
  }

  #loadData = async () => {
    if (!this.isInitialized && !this.isInitializing) return

    const response = await this.api.getFavorites()

    if (!response) {
      console.error('[Favorites] Failed to load')

      return
    }

    if (!response.data) {
      // FIXME: backend server should add promeet as favorite if user has no favorite stores
      if (response.status === 200) {
        const promeetUser = await this.users.getPromeetUser()
        await promeetUser.toggleFavorite()

        return this.#loadData()
      }

      return
    }

    runInAction(() => {
      this.favoriteUsers = response.data
        .map(x => {
          // FIXME: api should return favorite flag true
          x.favorites = 0

          return this.users.createOrUpdate(x)
        })
        .filter(x => x !== null)
    })
  }
}
